require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-como-puede-el-bid-fortalecer-el-proceso-de-revision.json") })
        }
      }, "path---es-mx-update-como-puede-el-bid-fortalecer-el-proceso-de-revision");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-como-puede-el-bid-fortalecer-el-proceso-de-revision!./.cache/json/es-mx-update-como-puede-el-bid-fortalecer-el-proceso-de-revision.json
// module id = 923
// module chunks = 231608221292675